// extracted by mini-css-extract-plugin
module.exports = {"background":"_2bslj"};